import {
  GetTokenOptions,
  IAction,
  OrgType,
} from '@sennder/senn-node-microfrontend-interfaces'

import { auth } from '@/modules/auth'

const DEFAULT_AUDIENCE = 'https://api.cloud.sennder.com'
const DEFAULT_ORG_ID = 'sennder'
const DEFAULT_ORG_TYPE = OrgType.ORGANIZATION

const defaultTokenOptions: GetTokenOptions = {
  usePopup: false,
  throwException: false,
}

export const getAuthToken = async (
  options: GetTokenOptions = defaultTokenOptions
) => {
  if (!auth.value) {
    throw new Error('[tms-shell - getAuthToken]: Auth module is not loaded')
  }

  const audience = options.audience || DEFAULT_AUDIENCE
  const enrichedOptions = { ...options, audience }

  const token = (await auth.value.getAuthToken(enrichedOptions)) || null

  return token
}

export const getAuthHeader = async (
  options: GetTokenOptions = defaultTokenOptions
) => {
  const token = await getAuthToken(options)
  return token ? `Bearer ${token}` : null
}

export async function getCommonHeaders() {
  if (!auth.value) {
    throw new Error('[tms-shell - getCommonHeaders]: Auth module is not loaded')
  }

  const headers = await auth.value.getCommonHeaders(DEFAULT_AUDIENCE)

  return {
    ...headers,
    'X-Org-Type': DEFAULT_ORG_TYPE,
    'X-Org-Id': DEFAULT_ORG_ID,
  }
}

export async function getPermissions(actions: IAction[]) {
  if (!auth.value) {
    throw new Error('[tms-shell - getPermissions]: Auth module is not loaded')
  }
  return await auth.value.getPermissions(actions, DEFAULT_AUDIENCE)
}
